<header class="layout-grid">
    <mat-toolbar fixedInViewPort>
        <div class="header__logo">
            <a [routerLink]="homeLink"><img [src]="logo" alt="Teller Online Admin Portal"></a>
        </div>
        <nav aria-label="Primary" class="navigation">
            <ng-container *ngIf="authService.isAuthenticated">
                <ng-container *ngIf="!appService.currentPage('/config')">
                    <a mat-button
                        routerLink="/payments"
                        routerLinkActive="navigation-link--active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        class="navigation-link"
                        [attr.aria-current]="appService.ariaCurrent('/payments', true)">
                        <mat-icon svgIcon="select-payment" class="teller-online-icon"></mat-icon>
                        <span>Payments</span>
                    </a>

                    <!-- TODO (TOP-2067): Re-enable once the scheduled
                        payments detail page has a proper design -->
                    <!--<a mat-button
                        routerLink="/scheduled-payments"
                        routerLinkActive="navigation-link--active"
                        class="navigation-link"
                        [attr.aria-current]="appService.ariaCurrent('/scheduled-payments')">
                        <mat-icon>event_repeat</mat-icon>
                        <span>Schedules</span>
                    </a>-->

                    <a mat-button
                        *ngIf="siteMetadataService.authenticationEnabled"
                        routerLink="/users"
                        routerLinkActive="navigation-link--active"
                        class="navigation-link"
                        [attr.aria-current]="appService.ariaCurrent('/users')">
                        <mat-icon svgIcon="user" class="teller-online-icon"></mat-icon>
                        <span>Users</span>
                    </a>
                    
                    <button mat-button
                        [matMenuTriggerFor]="profilenav" 
                        class="navigation-group" 
                        [ngClass]="{'navigation-group--active': appService.currentPage('/profile')}">
                        <mat-icon svgIcon="logout" class="teller-online-icon"></mat-icon>
                        {{ (authService.currentUser$ | async).name }}
                        <mat-icon>expand_more</mat-icon>
                    </button>

                    <mat-menu #profilenav="matMenu" class="navigation">
                        <button mat-menu-item (click)="onClick_signOut()" class="navigation-link">Sign Out</button>
                    </mat-menu>
                </ng-container>

                <ng-container *ngIf="appService.currentPage('/config')">
                    <button mat-button
                        [matMenuTriggerFor]="importexport"
                        class="navigation-group">
                        <mat-icon>settings</mat-icon>
                        Import/Export Config
                        <mat-icon>expand_more</mat-icon>
                    </button>

                    <mat-menu #importexport="matMenu">
                        <button mat-menu-item (click)="onClick_import()">Import</button>
                        <button mat-menu-item (click)="onClick_export()">Export</button>
                    </mat-menu>

                    <button mat-icon-button
                        (click)="onClick_help()"
                        class="help-button"
                        aria-controls="help-sidebar"
                        [attr.aria-expanded]="helpOpened"
                        aria-label="Help"
                        matTooltip="Help">
                        <mat-icon svgIcon="help"></mat-icon>
                    </button>
                </ng-container>
            </ng-container>
        </nav>
    </mat-toolbar>
</header>
